import { NoteCardWebComponent } from './component/NoteCardWebComponent';
import { WEB_COMPONENT_NOTE_CARD } from '../../webcomponents.constants';

export { NoteCardWebComponent };

window.customElements.define(WEB_COMPONENT_NOTE_CARD, NoteCardWebComponent);
